import { render } from "./OnboardingPlanPicker.vue?vue&type=template&id=55eaa5c0&scoped=true"
import script from "./OnboardingPlanPicker.vue?vue&type=script&lang=js"
export * from "./OnboardingPlanPicker.vue?vue&type=script&lang=js"

import "./OnboardingPlanPicker.vue?vue&type=style&index=0&id=55eaa5c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55eaa5c0"]])

export default __exports__